import React, { useState } from "react";
import {
  CPage,
  CRow,
  CDropDown,
  CPanel,
  H3,
  Text
} from "@appcues/component-library";
import styled from "styled-components";
import isEqual from "lodash.isequal";
import IndexPage from "components/Common/IndexPage";
import SelectSegmentDropDown from "components/Common/SelectSegmentDropDown";
import Sources from "./Sources";
import EventsChart from "./EventsChart";

const StyledCRow = styled(CRow)`
  > div {
    padding-right: 1em;
  }
`;

const ExploreEvents = () => {
  const [startTime, setStartTime] = useState("7 days ago");
  const [segmentId, setSegmentId] = useState(null);
  const [selectedEvents, setSelectedEvents] = useState([]);

  const startTimeOptions = [7, 30, 60, 90].map(days => ({
    value: `${days} days ago`,
    label: `Last ${days} days`
  }));

  const handleSelectEvent = event => {
    const matchingEvent = selectedEvents.find(existingEvent =>
      isEqual(existingEvent, event)
    );
    if (matchingEvent) {
      setSelectedEvents(current => current.filter(it => it !== matchingEvent));
    } else {
      setSelectedEvents(current => [...current, event]);
    }
  };

  return (
    <IndexPage
      title="Explore Events"
      description="View and compare event data to learn more about your product."
      shouldHideFirebaseSaveIndicator
    >
      <CPage.Container>
        <StyledCRow>
          <CDropDown
            value={startTime}
            options={startTimeOptions}
            onChange={setStartTime}
          />
          <SelectSegmentDropDown
            value={segmentId}
            onChange={setSegmentId}
            isSearchable
            isClearable
          />
        </StyledCRow>
        <CRow>
          <CPanel marginBottom={24}>
            <H3>Overview</H3>
            <Text>Metrics about the performance of your events</Text>
            <EventsChart startTime={startTime} segmentId={segmentId} />
          </CPanel>
        </CRow>
        <CRow>
          <Sources
            startTime={startTime}
            segmentId={segmentId}
            selectedEvents={selectedEvents}
            onSelectEvent={handleSelectEvent}
          />
        </CRow>
      </CPage.Container>
    </IndexPage>
  );
};

export default ExploreEvents;
